import '../App.css';
import React, { useState, useEffect, useRef, forwardRef } from 'react';
import logo from '../logo.png'
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment/moment';
import { FaUserFriends } from "react-icons/fa";
import { FaUserTie } from "react-icons/fa";
import ReactModal from 'react-modal';
import { toast } from 'wc-toast'
import { add_icon, add_image, add_video, delete_icon, view_icon } from '../assets/Icons';
import { IoIosCloseCircle } from "react-icons/io";
import { db, storage } from '../config';
import { decrypt, encrypt } from '../Crypto';
import { MdAddPhotoAlternate } from "react-icons/md";
import { RiVideoAddFill } from "react-icons/ri";
import { Levels } from 'react-activity';
import "react-activity/dist/library.css";
import Select, { components } from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { connect } from 'react-redux';
import { FaRegCheckSquare } from "react-icons/fa";
import { MdCheckBoxOutlineBlank } from "react-icons/md";
import { Collapse } from 'react-collapse';
import { SetId } from './redux/actions';
import BackDrop from './Backdrop';
import { VscThreeBars } from 'react-icons/vsc';
import { FiImage, FiClock, FiSettings } from "react-icons/fi";
import ImageGeneratorUI from './ImageGeneratorUI';
import SaveImageModal from './SaveImageModal';
import SavedModal from './SavedModal';
import ResizeModal from './ResizeModal';
import RegenerateModal from './RegenerateModal';
import AILoader from './AILoader';

const history_icon = <FiClock color='black' size={22} />

const userdb = db.ref('userdb');
const calendardb = db.ref('calendardb');
const serialdb = db.ref('serialdb');

const recruiter_active = <FaUserTie color='white' size={22} />
const recruiter_active_non = <FaUserTie color='#B9B9B9' size={22} />

const DATA = [
    { id: 'bd7acbea-c1b1-46c2-aed5-3ad53abb28ba', title: 'Dancer', uri: 'https://randomuser.me/api/portraits/men/32.jpg', name: 'Pablo ' },
    { id: '3ac68afc-c605-48d3-a4f8-fbd91aa97f63', title: 'Dancer ', uri: 'https://randomuser.me/api/portraits/men/79.jpg', name: 'Rodriguez ' },
    { id: '58694a0f-3da1-41f-bd96-145571e29d72', title: 'Dancer ', uri: 'https://randomuser.me/api/portraits/men/31.jpg', name: 'Maxi milianos ' },
    { id: '58694a0f-3da1-471f-bd96-145571e29d7', title: 'Dancer ', uri: 'https://randomuser.me/api/portraits/men/30.jpg', name: 'Leo' },
    { id: '58694a0f-3da1-471f-bd96-145571e29d2', title: 'Dancer ', uri: 'https://randomuser.me/api/portraits/men/42.jpg', name: 'Golin' },
    { id: '58694a0f-3da1-471f-bd96-145571e29d7-2', title: 'Dancer ', uri: 'https://randomuser.me/api/portraits/men/70.jpg', name: 'Leo' },
    { id: '58694a0f-3da1-471f-bd96-145571e29d2-2', title: 'Dancer ', uri: 'https://randomuser.me/api/portraits/men/42.jpg', name: 'Golin' },
    { id: '58694a0f-3da1-471f-bd96-145571e29d7-3', title: 'Dancer ', uri: 'https://randomuser.me/api/portraits/men/30.jpg', name: 'Leo' },
    { id: '58694a0f-3da1-471f-bd96-145571e29d2-3', title: 'Dancer ', uri: 'https://randomuser.me/api/portraits/men/52.jpg', name: 'Golin' }
];

const MainItem = (label, onClick, width) => (
    <div
        onClick={onClick}
        style={{
            cursor: 'pointer',
            marginTop: label == 'Devices' ? 5 : 5,
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            width: 0.18 * width,
            padding: 10,
            alignSelf: 'center',
            alignItems: 'center',
            height: 52
        }}
    >
        <div
            style={{
                width: 0.14 * width,
                flexDirection: 'row',
                display: 'flex',
                padding: 10,
                borderRadius: 6,
                height: 52,
                alignItems: 'center',
                justifyContent: 'space-between'
            }}
        >
            <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>
                {label}
            </text>
            <div style={{ height: 41, width: 20 }} />
        </div>
    </div>
);

function AICreate({ items, SetId }) {

    const [edit_second, setEditSecond] = useState(null)
    const [second, setSecond] = useState(0)

    const key = items.myid != null ? items.myid.id : null
    const navigate = useNavigate();

    useEffect(() => {
        if (items.myid == null) {
            let obj = localStorage.getItem('display')
            if (obj != null) { obj = JSON.parse(obj); SetId(obj) }
            else { navigate('/') }
        }
    }, [items])

    let curr = new Date().getTime();

    const [touched1, setTouched1] = useState(false);
    const [startDate, setStartDate] = useState(new Date().getTime())
    const [endDate, setEndDate] = useState(new Date().getTime())

    function generate_timing() {
        let arr = []
        for (let i = 1; i < 12; i++) {
            for (let j = 0; j < 60; j = j + 15) {
                arr.push({ value: ret_double(i) + " : " + ret_double(j), label: ret_double(i) + " : " + ret_double(j), hour: i, min: j })
            }
        }
        arr.push({ value: ret_double(12) + " : " + ret_double(0), label: ret_double(12) + " : " + ret_double(0), hour: 12, min: 0 })
        return arr
    }

    const [times, setTimes] = useState(generate_timing())

    function generate() {
        let arr = []
        for (let i = 0; i < 59; i++) {
            arr.push({ label: i + " s", value: i + " s", sec: i })
        }
        for (let i = 2; i < 6; i++) {
            arr.push({ label: i + " min", value: i + " min", sec: i * 60 })
        }
        return arr
    }

    const seconds = generate()

    function toggleTouched1() {
        setTouched1(!touched1);
    }

    function handleMouseUp1() {
        setTimeout(() => {
            setTouched1(!touched1);
        }, 150);
    }

    const [addImage, setAddImage] = useState(false)
    const [addVideo, setAddVideo] = useState(false)

    const [mycontent, setMycontent] = useState([])
    const [devices, setDevices] = useState([])

    const [picture, setPicture] = useState(null)
    const [imguri, setimguri] = useState(null)

    const [loading, setLoading] = useState(null)

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

    useEffect(() => {
        const subscribe = userdb.child(String(key)).child('content').on('value', (snapshot) => {
            if (snapshot != undefined && snapshot.val() != null) {
                let arr = Object.values(snapshot.val());
                for (let i = 0; i < arr.length; i++) {
                    arr[i].label = decrypt(arr[i].name) + `( ${arr[i].type} )`
                    arr[i].value = decrypt(arr[i].name) + `( ${arr[i].type} )`
                }
                setMycontent([...arr])
            }
        })
        return () => subscribe()
    }, [key])

    useEffect(() => {
        const subscribe = userdb.child(String(key)).child('devices').on('value', (snapshot) => {
            if (snapshot != undefined && snapshot.val() != null) {
                let arr = Object.values(snapshot.val());
                for (let i = 0; i < arr.length; i++) {
                    arr[i].label = decrypt(arr[i].name)
                    arr[i].value = decrypt(arr[i].name)
                }
                let obj = { label: 'All', value: 'All' }
                arr.unshift(obj)
                setDevices([...arr])
            }
            else {
                setDevices([])
            }
        })
        return () => subscribe()
    }, [key])

    const [mainSetup, setMainSetup] = useState([])
    const [mainAll, setMainAll] = useState([])

    async function getpreviousDayWork(key) {
        let now = new Date()
        now.setHours(1)
        now.setMinutes(0)
        now.setSeconds(0)
        now.setMilliseconds(0)
        now = now.getTime()
        let val = await calendardb.child(String(key)).orderByChild('end_dat').endAt(String(now)).once('value')
        val = val.val()
        console.log('Filtered  ...............', val)
    }

    async function getAllUsers() {
        let all = await db.ref('Sign_up').once('value')
        if (all.val() != null) {
            let arr = Object.values(all.val())
            for (let i = 0; i < arr.length; i++) {
                await getpreviousDayWork(arr[i].id)
            }
        }
    }

    useEffect(() => {
        getAllUsers()
    }, [])

    async function gettingAll() {
        let snapshot = await calendardb.child(String(key)).once('value')
        if (snapshot != undefined && snapshot.val() != null) {
            let arr = Object.values(snapshot.val());
            let tod = new Date()
            tod.setHours(11)
            tod.setMinutes(0)
            tod.setSeconds(0)
            tod.setMilliseconds(0)
            tod = tod.getTime()
            let temp = []
            for (let i = 0; i < arr.length; i++) {
                arr[i].id = String(arr[i].ID)
                if (Number(arr[i].end_dat) <= tod || Number(arr[i].end_dat) >= tod) {
                    temp.push(arr[i])
                }
            }
            temp.sort(function (a, b) { return a.index - b.index });
            setMainAll([...temp])
        }
        else setMainAll([])
    }

    useEffect(() => {
        gettingAll()
    }, [key])

    const ref = useRef()
    const ref1 = useRef()

    const handleClick = (e) => {
        ref.current.click()
    }

    const onChangePicture = e => {
        if (e.target.files[0]) {
            let file = e.target.files[0];
            const reader = new FileReader();
            if (file) {
                reader.addEventListener("load", () => {
                    setPicture(reader.result);
                    setimguri(file)
                });
            }
            reader.readAsDataURL(e.target.files[0]);
        }
    };

    const [delete_content, setDeleteContent] = useState(false)

    async function delet_content() {
        await calendardb.child(String(key)).child(String(delete_content)).remove()
        toast('Content is deleted !')
        gettingAll()
        setDeleteContent(false)
    }

    const [modal, setModal] = useState(false)

    function today_dat(str) {
        return new Date(str).getDate() + " " + months[new Date(str).getMonth()] + " " + new Date().getFullYear()
    }

    const DateInput1 = forwardRef(
        ({ onClick, value }, ref) => (
            <div ref={ref} onClick={onClick} style={{ zIndex: 1000, width: 225, display: 'flex', backgroundColor: 'white', height: 38, borderRadius: 4, justifyContent: 'center', alignItems: 'center', alignSelf: 'center', marginTop: 4 }}>
                <text style={{ color: 'black', fontWeight: '400', fontSize: 15, }}>{today_dat(startDate)}</text>
            </div>
        )
    );

    const DateInput2 = forwardRef(
        ({ onClick, value }, ref) => (
            <div ref={ref} onClick={onClick} style={{ zIndex: 1000, width: 225, display: 'flex', backgroundColor: 'white', height: 38, borderRadius: 4, justifyContent: 'center', alignItems: 'center', alignSelf: 'center', marginTop: 4 }}>
                <text style={{ color: 'black', fontWeight: '400', fontSize: 15, }}>{today_dat(endDate)}</text>
            </div>
        )
    );

    const [curr_device, setCurrDevice] = useState(null)
    const [curr_content, setCurrContent] = useState(null)
    const [timing, setTiming] = useState(0)

    const [start, setStart] = useState(null)
    const [end, setEnd] = useState(null)

    async function updateTiming() {
        if (edit_second != null && second != 0) {
            await calendardb.child(String(key)).child(String(edit_second.ID)).update({ timing: second })
            setEditSecond(null)
            setSecond(0)
            gettingAll()
            toast('Timing has been updated')
        }
    }

    async function add_to_calendar() {
        if (curr_device != null && curr_content != null && timing != 0 && ((start != null && end != null && end.type != undefined && start.type != undefined) || full_time)) {
            let ID = new Date().getTime()
            let obj = {
                ID: ID,
                start_dat: String(new Date(startDate).getTime()),
                end_dat: String(new Date(endDate).getTime()),
                device: curr_device,
                content: curr_content,
                timing: timing,
                start: start,
                end: end,
                full_time
            }
            await calendardb.child(String(key)).child(String(ID)).set(obj)
            if (curr_device != 'All') toast(`${decrypt(curr_content.name)} has been added to device ${decrypt(curr_device.name)}`)
            else toast(`${decrypt(curr_content.name)} has been added to all devices`)
            gettingAll()
            setStart(null)
            setEnd(null)
            setCurrContent(null)
            setCurrDevice(null)
            setTiming(0)
            setStartDate(new Date().getTime())
            setEndDate(new Date().getTime())
            setModal(false)
            setFullTime(false)
        }
        else toast('Empty fields are not accepted !')
    }

    function ret_double(str) {
        let st = String(str)
        if (st.length == 1) return '0' + st
        else return st
    }

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    function Quote({ quote, index }) {
        return (
            !isMobile ? <Draggable draggableId={quote.id} index={index}>
                {provided => (
                    <div onClick={(e) => { setDeleteContent(quote.ID) }} style={{ height: 60, width: 0.74 * width, backgroundColor: 'white', display: 'flex', alignSelf: 'center', justifyContent: 'space-between', alignContent: 'center' }}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                    >
                        <div onClick={(e) => { setDeleteContent(quote.ID) }} onMouseLeave={() => { setCursorImg(null); setCursorVid(null) }} onMouseEnter={() => { if (quote.content.type == 'image') { setCursorImg(quote.content.uri); setCursorVid(null) } else { setCursorVid(quote.content.uri); setCursorImg(null) } }} style={{ width: 0.74 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 20 }}>
                            <div style={{ display: 'flex', height: 56, width: 0.11 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5, flexDirection: 'column' }}>
                                <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{today_dat(Number(quote.start_dat))}</text>
                                <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center', marginTop: 4 }}>{today_dat(Number(quote.end_dat))}</text>
                            </div>
                            {quote.device != 'All' ? <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{`${decrypt(quote.device.name)}`} - {`${quote.device.ID}`}</text>
                            </div> : <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{`${quote.device}`}</text>
                            </div>}
                            <div style={{ display: 'flex', height: 56, width: 0.08 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                {!quote.full_time && <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{`${ret_double(quote.start.hr)}`} : {`${ret_double(quote.start.min)}`} {`${quote.start.type}`}</text>}
                                {quote.full_time && <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>24 Hours</text>}
                            </div>
                            <div style={{ display: 'flex', height: 56, width: 0.07 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                {!quote.full_time && <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{`${ret_double(quote.end.hr)}`} : {`${ret_double(quote.end.min)}`} {`${quote.end.type}`}</text>}
                                {quote.full_time && <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>24 Hours</text>}
                            </div>
                            <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{`${decrypt(quote.content.name)}`}</text>
                            </div>
                            <div onClick={(e) => { e.stopPropagation(); setEditSecond({ ...quote }); setSecond(quote.timing) }} style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.14 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                <text style={{ color: 'white', fontSize: 11, fontWeight: '600', textAlign: 'center' }}>{`${quote.timing} s`} <text style={{ fontSize: 18 }}>{quote.content.type == 'image' ? '✍️' : null}</text></text>
                            </div>
                            <div onClick={(e) => { e.stopPropagation(); setDeleteContent(quote.ID) }} style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.08 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>{delete_icon}</text>
                            </div>
                        </div>
                    </div>
                )}
            </Draggable> : <Draggable draggableId={quote.id} index={index}>
                {provided => (
                    <div onClick={(e) => { setDeleteContent(quote.ID) }} style={{ height: 60, width: 0.94 * width, backgroundColor: 'white', display: 'flex', alignSelf: 'center', justifyContent: 'space-between', alignContent: 'center' }}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                    >
                        <div onClick={(e) => { setDeleteContent(quote.ID) }} onMouseLeave={() => { setCursorImg(null); setCursorVid(null) }} onMouseEnter={() => { if (quote.content.type == 'image') { setCursorImg(quote.content.uri); setCursorVid(null) } else { setCursorVid(quote.content.uri); setCursorImg(null) } }} style={{ width: 0.94 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 20 }}>
                            <div style={{ display: 'flex', height: 56, width: 0.11 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5, flexDirection: 'column' }}>
                                <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center' }}>{today_dat(Number(quote.start_dat))}</text>
                                <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center', marginTop: 4 }}>{today_dat(Number(quote.end_dat))}</text>
                            </div>
                            {quote.device != 'All' ? <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center' }}>{`${decrypt(quote.device.name)}`} - {`${quote.device.ID}`}</text>
                            </div> : <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center' }}>{`${quote.device}`}</text>
                            </div>}
                            <div style={{ display: 'flex', height: 56, width: 0.13 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                {!quote.full_time && <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center' }}>{`${ret_double(quote.start.hr)}`} : {`${ret_double(quote.start.min)}`} {`${quote.start.type}`}</text>}
                                {quote.full_time && <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center' }}>24 Hours</text>}
                            </div>
                            <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                {!quote.full_time && <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center' }}>{`${ret_double(quote.end.hr)}`} : {`${ret_double(quote.end.min)}`} {`${quote.end.type}`}</text>}
                                {quote.full_time && <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center' }}>24 Hours</text>}
                            </div>
                            <div style={{ display: 'flex', height: 56, width: 0.20 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5, wordBreak: 'break-all' }}>
                                <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center' }}>{`${decrypt(quote.content.name)}`}</text>
                            </div>
                            <div onClick={(e) => { e.stopPropagation(); setEditSecond({ ...quote }); setSecond(quote.timing) }} style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.16 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center' }}>{`${quote.timing} s`} <text style={{ fontSize: 18 }}>{quote.content.type == 'image' ? '✍️' : null}</text></text>
                            </div>
                            <div onClick={(e) => { e.stopPropagation(); setDeleteContent(quote.ID) }} style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.08 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                <text style={{ color: 'white', fontSize: 11, fontWeight: '600', textAlign: 'center' }}>{delete_icon}</text>
                            </div>
                        </div>
                    </div>
                )}
            </Draggable>
        );
    }

    const QuoteList = React.memo(function QuoteList({ quotes }) {
        return quotes.map((quote, index) => (
            <Quote quote={quote} index={index} key={quote.id} />
        ));
    });

    function onDragEnd(result) {
        if (!result.destination) return;
        if (result.destination.index === result.source.index) return;

        const items2 = reorder(
            mainSetup,
            result.source.index,
            result.destination.index
        );

        setMainSetup([...items2])
        updateSerial(items2)
    }

    async function updateSerial(mains) {
        let arr = {};
        let obj = {}
        for (let i = 0; i < mains.length; i++) {
            arr[mains[i].ID] = mains[i]
            obj = arr[mains[i].ID]
            obj['index'] = i
            arr[mains[i].ID] = obj
        }
        await calendardb.child(String(key)).set(arr)
    }

    const [cursor_img, setCursorImg] = useState(null)
    const [cursor_vid, setCursorVid] = useState(null)

    const [selectedOption, setSelectedOption] = useState(null);

    useEffect(() => {
        if (selectedOption == null) {
            let temp = [...mainAll]
            setMainSetup([...temp])
        }
        else if (selectedOption != null) {
            let temp = [...mainAll]
            let arr = []
            for (let i = 0; i < temp.length; i++) {
                if (temp[i].device.ID == selectedOption) {
                    arr.push(temp[i])
                }
            }
            setMainSetup([...arr])
        }
    }, [mainAll, selectedOption])

    const [time, setTime] = useState(Date.now())

    useEffect(() => {
        const interval = setInterval(() => setTime(Date.now()), 1000 * 120)
        return () => {
            clearInterval(interval)
        }
    }, [])

    const [full_time, setFullTime] = useState(false)

    const [width, setwidth] = useState(window.innerWidth);
    const [height, setWindowHeight] = useState(1600);

    useEffect(() => {
        const windowSizeHandler = () => {
            setwidth(window.innerWidth)
            setWindowHeight(1600)
        };
        window.addEventListener("resize", windowSizeHandler);

        return () => {
            window.removeEventListener("resize", windowSizeHandler);
        };
    }, []);

    const isMobile = width <= 768;

    // ✅ you asked: wider drawer on mobile (0.80)
    const drawerW = isMobile ? width * 0.80 : width * 0.20;

    const [drawerOpen, setDrawerOpen] = useState(false);

    function handleOpenDrawerButton() {
        setDrawerOpen(!drawerOpen);
    }

    function handleBackdropClick() {
        setDrawerOpen(false);
    }

    let drawerClasses = drawerOpen ? "side-drawer open" : "side-drawer";

    const [show_save_modal, setShowSaveModal] = useState(false);
    const [show_saved_modal, setShowSavedModal] = useState(false);
    const [show_resize_modal, setShowResizeModal] = useState(false);

    useEffect(() => {
        const subscribe = db.ref(`ai_settings/${key}`).on('value', (snapshot) => {
            if (snapshot != undefined && snapshot.exists()) {
            }
            else if (snapshot != undefined) {
                navigate('/AISetting')
            }
        });

        return () => {
            subscribe();
        };
    }, [])

    const [credit, setCredit] = useState(0)

    useEffect(() => {
        const subscribe = userdb.child(String(key)).child('credit').on('value', (snap) => {
            if (snap != undefined && snap.val() != null) {
                setCredit(snap.val())
                if (snap.val() < 1) {
                    toast.error('Not enough credits to generate New Image')
                }
            }
            else if (snap != undefined) {
                setCredit(15)
            }
        })
        return () => subscribe()
    }, [key])

    async function deductCredit(cost = 1.0) {
        let updated = credit - cost < 0 ? 0 : Number(credit - cost).toFixed(2)
        await userdb.child(String(key)).child('credit').set(updated)
    }

    const [business_name, setBusinessName] = useState('')
    const [company_name, setCompanyName] = useState('')
    const [business_do, setBusinessDo] = useState('')
    const [business_type, setBusinessType] = useState('')
    const [target_audience, setTargetAudience] = useState('')

    const [brandColors, setBrandColors] = useState(['#FFFFFF', '#FFFFFF', '#FFFFFF'])
    const [fontStylePreference, setFontStylePreference] = useState('')
    const [overallStylePreference, setOverallStylePreference] = useState('')
    const [logos, setLogos] = useState([])
    const [referenceImages, setReferenceImages] = useState([])

    useEffect(() => {
        const subscribe = db.ref(`ai_settings/${key}`).on('value', (snapshot) => {
            if (snapshot != undefined && snapshot.exists()) {
                setLogos(snapshot.val().logos ? snapshot.val().logos.map(item => item.url) : []);
                setReferenceImages(snapshot.val().referenceImages ? snapshot.val().referenceImages.map(item => item.url) : []);
                setBrandColors(snapshot.val().brandColors || []);
                setFontStylePreference(snapshot.val().fontStylePreference || '');
                setOverallStylePreference(snapshot.val().overallStylePreference || '');
                setCompanyName(snapshot.val().company_name || '');
                setBusinessName(snapshot.val().business_name || '');
                setBusinessDo(snapshot.val().business_do || '');
                setBusinessType(snapshot.val().business_type || '');
                setTargetAudience(snapshot.val().target_audience || '');
            }
        });

        return () => {
            subscribe();
        };
    }, [])

    const { state } = useLocation()

    const [styleImage, setStyleImage] = useState('')
    const [shapeImage, setShapeImage] = useState('')
    const [description_image, setDescriptionImage] = useState('')
    const [not, setNot] = useState('')

    const [generateImageBase64, setGenerateImageBase64] = useState(null)
    const [myImageId, setMyImageId] = useState(null)
    const [useLogo, setUseLogo] = useState(true)
    const [position, setPosition] = useState('top-right')

    async function uploadFile(base64, path) {
        const storageRef = storage.ref(path)
        await storageRef.putString(base64, 'base64');
        return await storageRef.getDownloadURL();
    }

    async function uploadFiles(base64, imageId, userId, name) {
        const filePath = `${userId}/${imageId}/${name}`;
        return await uploadFile(base64, filePath);
    }

    function processSaveImage() {
        if (generateImageBase64 != null && myImageId != null) {
            let image_obj = {
                image_id: myImageId,
                donot: not,
                preferredStyle: styleImage,
                description: description_image,
                imagesize: shapeImage,
                generated_url: generateImageBase64
            }
            setShowSaveModal(image_obj)
        }
        else {
            toast.error('AI Image not available yet')
        }
    }

    const [base_64, setBase64] = useState(null)
    const [changed_64, setChanged64] = useState(null)
    const genDiv = useRef(null)

    console.log('Key ......', key, ' ', logos)

    async function generateImage() {
        if (credit >= 1.0) {
            setLoading(true)

            let generate_obj = {
                donot: not,
                preferredStyle: styleImage,
                description: description_image,
                imagesize: shapeImage,
                businessName: business_name,
                industry: company_name,
                businessDescription: business_do,
                businessType: business_type,
                targetAudience: target_audience,
                brandColors,
                fontStyle: fontStylePreference,
                overallStyle: overallStylePreference,
                logos,
                referenceImages,
                user: String(key),
                position: position,
                logo_enable: (logos != undefined && logos != null && logos.length > 0) ? useLogo : false
            }

            let image_id = new Date().getTime()
            setMyImageId(image_id)

            let image_obj = {
                image_id: image_id,
                donot: not,
                preferredStyle: styleImage,
                description: description_image,
                imagesize: shapeImage,
                position: position,
                logo_enable: (logos != undefined && logos != null && logos.length > 0) ? useLogo : false
            }

            const res = await fetch("https://us-central1-boomdisplays-3e87d.cloudfunctions.net/app/generate-brand-image", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(generate_obj),
            });

            const data = await res.json();

            if (!data.success) {
                toast.error("Image generation failed");
                setLoading(false)
                return;
            }

            setBase64(data.image)
            setLoading(false)
            toast.success('Image generated successfully.')
            genDiv.current?.scrollIntoView({ behavior: "smooth" });

            image_obj.generated_url = await uploadFiles(data.image, image_obj.image_id, key, 'generated_ai_image.png')
            setGenerateImageBase64(image_obj.generated_url)
            await db.ref('generated_image').child(String(key)).child(String(image_obj.image_id)).set(image_obj)
            await deductCredit(1.0)
        }
        else {
            toast.error('Not enough credits')
        }
    }

    async function tracKAllPreviousImages(regenerate_id, url, image_id) {
        let new_obj = { ID: regenerate_id, url: url }
        await db.ref('regenerated').child(String(key)).child(String(image_id)).child(String(new_obj.ID)).set(new_obj)
    }

    async function reGenerateImage(promt) {
        if (credit >= 0.5) {
            if (promt != '') {
                setLoading(true)
                setUpdatedModal(false)

                let generate_obj = {
                    logos,
                    position: position,
                    size: shapeImage,
                    user: String(key),
                    prompt: promt,
                    base64: changed_64 == null ? base_64 : changed_64
                }

                let image_id = myImageId

                let image_obj = {
                    image_id: image_id,
                    donot: not,
                    preferredStyle: styleImage,
                    description: description_image,
                    imagesize: shapeImage
                }

                const res = await fetch("https://us-central1-boomdisplays-3e87d.cloudfunctions.net/app/regenerate-brand-image", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(generate_obj),
                });

                const data = await res.json();

                if (!data.success) {
                    toast.error("Image generation failed");
                    setLoading(false)
                    return;
                }

                const regenerate_id = new Date().getTime()
                image_obj.generated_url = await uploadFiles(data.image, regenerate_id, key, 'generated_ai_image.png')

                setBase64(data.image)
                setLoading(false)

                await tracKAllPreviousImages(regenerate_id, generateImageBase64, myImageId)

                setGenerateImageBase64(image_obj.generated_url)
                await db.ref('generated_image').child(String(key)).child(String(image_obj.image_id)).set(image_obj)
                toast.success('Image re-generated successfully.')
                await deductCredit(0.5)
            }
            else {
                toast.error('Please enter a prompt')
            }
        }
        else {
            toast.error('Not enough credits')
        }
    }

    useEffect(() => {
        const style = document.createElement("style");
        style.innerHTML = `
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []);

    function downloadImage(fileName = "AI-image.png") {
        const link = document.createElement("a");
        link.href = generateImageBase64;
        link.download = fileName;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success('Image has been downloaded successfully')
    }

    const [folder, setFolder] = useState({})
    const [image_name, setImageName] = useState('')
    const [myfolders, setMyfolders] = useState([])

    useEffect(() => {
        const subscribe = userdb.child(String(key)).child('folder').on('value', (snapshot) => {
            if (snapshot != undefined && snapshot.val() != null) {
                let arr = Object.values(snapshot.val());
                for (let i = 0; i < arr.length; i++) {
                    arr[i].name = decrypt(arr[i].name)
                    arr[i].value = arr[i].name
                    arr[i].label = arr[i].name
                }
                setMyfolders([...arr])
            }
            else setMyfolders([])
        })
        return () => subscribe()
    }, [key])

    async function add_to_folder() {
        if (folder.ID != undefined && image_name != '') {
            let content_obj = {
                ID: new Date().getTime(),
                folder: folder.ID,
                name: encrypt(image_name),
                type: 'image',
                upload: encrypt('ai_generated'),
                uri: show_save_modal.generated_url
            }
            await userdb.child(String(key)).child('content').child(String(content_obj.ID)).set(content_obj)
            toast.success('Image is saved successfully')
            setShowSavedModal(true)

            setImageName('')
            setFolder({})
            setShowSaveModal(false)
        }
        else toast.error(' Please complete all required fields.')
    }

    async function send_for_calendar() {
        if (myImageId != null && generateImageBase64 != null) {
            let curr_content = {
                ID: new Date().getTime(),
                name: encrypt('AI Generated Image'),
                type: 'image',
                uri: generateImageBase64
            }
            navigate('/Calendars', { state: { curr_content } })
        }
        else {
            toast.error('AI Image not available yet')
        }
    }

    useEffect(() => {
        if (items.myid == null) {
            let obj = localStorage.getItem('display')
            if (obj != null) { obj = JSON.parse(obj); SetId(obj) }
            else { navigate('/') }
        }
    }, [items])

    const [updatedModal, setUpdatedModal] = useState(false)

    // ✅ 1) SubItem improved: ellipsis + never wraps in drawer
    const SubItem = ({ icon, label, active, onClick }) => (
        <div
            onClick={onClick}
            style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 14,
                height: isMobile ? 33 : 52,
                paddingLeft: 18,
                paddingRight: 20,
                marginBottom: 8,
                borderRadius: 12,
                backgroundColor: active ? "#1C222A" : "transparent",
                width: "100%",
                boxSizing: "border-box",
                overflow: "hidden",
            }}
        >
            <div
                style={{
                    width: 22,
                    minWidth: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: active ? "#F7941D" : "#9AA4B2",
                }}
            >
                {icon}
            </div>

            <span
                style={{
                    flex: 1,
                    minWidth: 0,
                    fontSize: label === "Create Images" ? 13 : isMobile ? 13 : 16,
                    fontWeight: 600,
                    lineHeight: "1",
                    color: active ? "#F7941D" : "#9AA4B2",
                    textAlign: "left",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
                title={label}
            >
                {label}
            </span>
        </div>
    );

    const Badge = (count, color, pos) => (
        <div
            style={{
                position: "absolute",
                top: 5,
                height: 20,
                width: 20,
                borderRadius: 12,
                backgroundColor: "white",
                border: `2px solid ${color}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                ...pos,
            }}
        >
            <text style={{ color, fontSize: 13 }}>{count}</text>
        </div>
    );

    // ✅ 2) LeftSubMenu fixed: aligned in desktop + NEVER goes outside in mobile
    const LeftSubMenu = ({ width }) => {
        const menuW = isMobile ? "100%" : (width * 0.14);

        return (
            <div
                style={{
                    display: "flex",
                    width: menuW,
                    marginLeft: isMobile ? 0 : 52,
                    marginTop: 8,
                    boxSizing: "border-box",
                    paddingLeft: isMobile ? 12 : 0,
                    paddingRight: isMobile ? 12 : 0,
                    overflow: "hidden",
                }}
            >
                {/* vertical line */}
                <div
                    style={{
                        width: isMobile ? 3 : 4,
                        backgroundColor: "#2E3642",
                        borderRadius: 4,
                        marginRight: isMobile ? 10 : 14,
                    }}
                />

                <div style={{ flex: 1, minWidth: 0 }}>
                    <SubItem icon={<FiImage />} label="Create Images" active />
                    <SubItem icon={<FiClock />} label="History" onClick={() => navigate("/AIGenerator")} />
                    <SubItem icon={<FiSettings />} label="Settings" onClick={() => navigate("/AISetting")} />
                </div>
            </div>
        );
    };

    // ✅ 3) One-line titles in mobile drawer
    const mobileDrawerTitleStyle = (maxW) => ({
        color: "white",
        marginLeft: 18,
        fontWeight: "600",
        fontSize: 15,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: maxW,
        display: "block",
    });

    return (
        !isMobile ? <div style={{ position: 'relative', backgroundColor: '#080A0C', display: 'flex', flexDirection: 'row', width: width, height: height, position: 'absolute', top: 0, left: 0 }}>

            <RegenerateModal
                open={updatedModal}
                onClose={() => { setUpdatedModal(false) }}
                base64={base_64}
                setNewBase64={setChanged64}
                onConfirm={reGenerateImage}
            />

            <AILoader loading={loading} />

            <div
                style={{
                    backgroundColor: "#080A0C",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    display: "flex",
                    flexDirection: "column",
                    height: height,
                    width: width * 0.2,
                    textAlign: 'center'
                }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: "#080A0C", width: width * 0.20, height: 100, justifyContent: 'center', alignItems: 'center' }}>
                    <img src={logo} alt="Logo" style={{ width: 113, marginTop: 1, height: 53 }} />
                </div>

                {items.show_welcome ? <div onClick={() => navigate('/Welcome')} style={{ cursor: 'pointer', marginTop: 20, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>

                    <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Welcome</text>
                        <div style={{ height: 41, width: 20 }} />
                    </div>
                </div> : null}

                {MainItem("Devices", () => navigate("/Devices"), width)}
                {MainItem("Content", () => navigate("/Content"), width)}
                {MainItem("Calendar", () => navigate("/Calendars"), width)}

                <div style={{ marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52 }}>
                    <div style={{ backgroundColor: "#181E25", width: width * 0.14, height: 52, borderRadius: 6, padding: 10, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <text style={{ color: "white", marginLeft: 30, fontWeight: 600, fontSize: 16 }}>
                            AI Generator
                        </text>
                        <img src={require("../assets/right.png")} style={{ height: 41, width: 20 }} />
                    </div>
                </div>

                {/* ✅ FIXED SUBMENU */}
                <LeftSubMenu width={width} />

                <div
                    onClick={() => navigate("/Subscription")}
                    style={{
                        cursor: "pointer",
                        marginTop: 10,
                        display: "flex",
                        justifyContent: "center",
                        width: width * 0.18,
                        alignSelf: "center",
                    }}
                >
                    <div
                        style={{
                            width: width * 0.14,
                            height: 52,
                            borderRadius: 6,
                            padding: 10,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            position: "relative",
                        }}
                    >
                        <text style={{ color: "white", marginLeft: 30, fontWeight: 600, fontSize: 16 }}>
                            Subscription
                        </text>

                        {items.unlicensed > 0 && Badge(items.unlicensed, "red", { left: 5 })}
                        {items.trial > 0 && Badge(items.trial, "#F7941D", { right: 20 })}
                        <div style={{ height: 41, width: 20 }} />
                    </div>
                </div>

                {MainItem("Settings", () => navigate("/Settings"), width)}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: width * 0.20, width: width * 0.80, position: 'absolute', top: 0, height: height, backgroundColor: '#181E25', alignItems: 'flex-end' }}>

                <div style={{ display: 'flex', height: 100, width: width * 0.7991, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C' }}>

                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: (0.74 * width) - 105 }}>
                        <text style={{ marginLeft: 0, fontSize: 24, fontWeight: '700', letterSpacing: 1.01, color: 'white', textAlign: 'center' }}>Content</text>
                    </div>

                    <div onClick={() => {
                        navigate('/');
                        localStorage.removeItem('display')
                        localStorage.removeItem('devices')
                        SetId(null)
                    }} style={{ cursor: 'pointer', alignSelf: 'center', width: 105, height: 36, borderRadius: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderWidth: 1, borderStyle: 'solid', borderColor: '#F7941D' }}>
                        <text style={{ color: '#F7941D', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Log out</text>
                    </div>

                </div>

                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#181E25', width: width * 0.80, height: height - 100, alignItems: 'center' }}>

                    <div style={{ padding: 5, width: 0.75 * width, height: 50, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 20, backgroundColor: '#F7941D', borderRadius: 8 }}>

                        <div style={{ width: 0.73 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', }}>

                            <div style={{ width: 0.17 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', width: 302, justifyContent: 'center', alignContent: 'center', height: 35, backgroundColor: 'transparent', marginTop: 2, marginLeft: -5, padding: 4 }}>
                                    <text style={{ color: 'black', fontSize: 18, fontWeight: '600', textAlign: 'left' }}>Create AI Image</text>
                                </div>
                            </div>

                            <div style={{ width: 0.21 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', alignSelf: 'center', }}>
                                <div onClick={() => navigate('/AIGenerator')} style={{ cursor: 'pointer', display: 'flex', width: 160, height: 42, backgroundColor: '#FFFFFF', borderRadius: 10, justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
                                    {history_icon}
                                    <text style={{ fontWeight: '600', fontSize: 18, color: 'black', marginLeft: 6 }}>History</text>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div style={{ width: 0.74 * width, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 20 }}>
                        <ImageGeneratorUI
                            setUpdatedModal={setUpdatedModal}
                            useLogo={useLogo}
                            setUseLogo={setUseLogo}
                            position={position}
                            setPosition={setPosition}
                            base_64={base_64}
                            send={send_for_calendar}
                            reGenerateImage={reGenerateImage}
                            generateImageBase64={generateImageBase64}
                            generate={generateImage}
                            not={not}
                            setNot={setNot}
                            description_image={description_image}
                            setDescriptionImage={setDescriptionImage}
                            styleImage={styleImage}
                            setStyleImage={setStyleImage}
                            shapeImage={shapeImage}
                            setShapeImage={setShapeImage}
                            setShowResizeModal={setShowResizeModal}
                            save={processSaveImage}
                            download={downloadImage}
                        />
                    </div>

                    <div ref={genDiv} />
                </div>

            </div>

            <SaveImageModal onSave={add_to_folder} myfolders={myfolders == null ? [] : myfolders} image_name={image_name} setImageName={setImageName} folder={folder} setFolder={setFolder} setShowSavedModal={setShowSavedModal} open={show_save_modal} onClose={() => setShowSaveModal(false)} />

            <SavedModal onSend={() => send_for_calendar()} onClose={() => setShowSavedModal(false)} open={show_saved_modal} />

            <ResizeModal shapeImage={shapeImage} setShapeImage={setShapeImage} open={show_resize_modal} onClose={() => setShowResizeModal(false)} />

            <input id="actual" ref={ref} accept="image/*" onChange={onChangePicture} type="file" hidden={true} />
            <input id="actual" ref={ref1} accept="video/*" onChange={onChangePicture} type="file" hidden={true} />

            <wc-toast></wc-toast>

        </div> :
            <div style={{ position: 'relative', backgroundColor: '#080A0C', display: 'flex', flexDirection: 'row', width: width, height: height, position: 'absolute', top: 0, left: 0, overflowX: 'hidden' }}>

                <RegenerateModal
                    open={updatedModal}
                    onClose={() => { setUpdatedModal(false) }}
                    base64={base_64}
                    setNewBase64={setChanged64}
                    onConfirm={reGenerateImage}
                />

                <AILoader loading={loading} />
                {/* ✅ drawer width overridden by inline style (0.80 width) */}
                <div className={drawerClasses} style={{ width: drawerW }}>

                    <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: "#080A0C", width: drawerW, height: 60, justifyContent: 'center', alignItems: 'center' }}>
                        <img
                            src={logo}
                            alt="Logo"
                            style={{ width: 113, marginTop: 1, height: 53, alignSelf: 'center' }}
                        />
                    </div>

                    {/* CONTENT */}
                    {items.show_welcome ? <div onClick={() => navigate('/Welcome')} style={{ cursor: 'pointer', marginTop: 10, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                        <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                            <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Welcome</text>
                            <div style={{ height: 30, width: 20 }} />
                        </div>
                    </div> : null}

                    {/* DEVICES */}
                    <div onClick={() => navigate('/Devices')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                        <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                            <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Devices</text>
                            <div style={{ height: 30, width: 20 }} />
                        </div>
                    </div>

                    {/* CONTENT */}
                    <div onClick={() => navigate('/Content')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                        <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                            <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Content</text>
                            <div style={{ height: 30, width: 20 }} />
                        </div>
                    </div>

                    {/* CALENDAR */}
                    <div onClick={() => navigate('/Calendars')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                        <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                            <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Calendar</text>
                            <div style={{ height: 30, width: 20 }} />
                        </div>
                    </div>

                    {/* AI GENERATOR ACTIVE */}
                    <div style={{ marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW - 30, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30 }}>
                        <div style={{ backgroundColor: '#181E25', width: drawerW - 42, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 30, alignItems: 'center', justifyContent: 'space-between' }}>
                            <text style={mobileDrawerTitleStyle((drawerW - 32) - 46)}>AI Generator</text>
                            <img src={require('../assets/right.png')} style={{ height: 30, width: 20 }} />
                        </div>
                    </div>

                    {/* ✅ FIXED SUB MENU */}
                    <LeftSubMenu width={width} />

                    {/* SUBSCRIPTION */}
                    <div onClick={() => navigate('/Subscription')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                        <div style={{ position: 'relative', width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                            <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Subscription</text>
                            <div style={{ height: 30, width: 20 }} />
                            {items.unlicensed > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: 'red', top: 5, left: 5 }}>
                                <text style={{ color: 'red', fontSize: 13 }}>{items.unlicensed}</text>
                            </div>}
                            {items.trial > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: '#F7941D', top: 5, right: 20 }}>
                                <text style={{ color: '#F7941D', fontSize: 13 }}>{items.trial}</text>
                            </div>}
                        </div>
                    </div>

                    {/* SETTINGS */}
                    <div onClick={() => navigate('/Settings')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                        <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 30, alignItems: 'center', justifyContent: 'space-between' }}>
                            <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Settings</text>
                            <div style={{ height: 30, width: 20 }} />
                        </div>
                    </div>

                    {/* LOG OUT */}
                    <div onClick={() => {
                        navigate('/')
                        localStorage.removeItem('display')
                        localStorage.removeItem('devices')
                        SetId(null)
                    }} style={{
                        left: ((drawerW - 22) - 150) / 2,
                        position: 'absolute',
                        bottom: 10,
                        alignContent: 'center',
                        cursor: 'pointer',
                        alignSelf: 'center',
                        width: 150,
                        height: 36,
                        borderRadius: 6,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderWidth: 1,
                        borderStyle: 'solid',
                        borderColor: '#F7941D'
                    }}>
                        <text style={{ color: '#F7941D', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Log out</text>
                    </div>

                </div>

                {drawerOpen && <BackDrop closeDrawer={handleBackdropClick} />}

                <div style={{ display: 'flex', flexDirection: 'column', width: width, position: 'absolute', top: 0, height: height, backgroundColor: '#181E25', alignItems: 'flex-end' }}>

                    <div style={{ display: 'flex', height: 100, width: width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C' }}>

                        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: (width * 0.94) - 5 }}>
                            <div style={{ cursor: 'pointer', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <VscThreeBars size={30} color='white' onClick={handleOpenDrawerButton} />
                            </div>
                            <div style={{ marginLeft: 6, marginTop: 4 }}>
                                <stripe-buy-button
                                    buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                                    publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
                                >
                                </stripe-buy-button>
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#181E25', width: width, height: height - 100, alignItems: 'center' }}>

                        <div style={{ width: 0.94 * width, height: 115, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 20, backgroundColor: '#F7941D', borderRadius: 8 }}>

                            <div style={{ width: 0.93 * width, height: 115, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-around', alignSelf: 'center', }}>

                                <div style={{ width: (0.93 * width * 90) / 100, height: 45, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', alignSelf: 'center', marginTop: 4 }}>
                                    <text style={{ color: 'black', fontSize: 16, fontWeight: '700', textAlign: 'left' }}>Create AI Image</text>
                                </div>

                                <div onClick={() => navigate('/AIGenerator')} style={{ cursor: 'pointer', display: 'flex', width: 160, height: 42, backgroundColor: '#FFFFFF', borderRadius: 10, justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
                                    {history_icon}
                                    <text style={{ fontWeight: '600', fontSize: 16, color: 'black', marginLeft: 6 }}>History</text>
                                </div>

                            </div>
                        </div>

                        <div style={{ width: 0.94 * width, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 20 }}>
                            <ImageGeneratorUI
                                setUpdatedModal={setUpdatedModal}
                                useLogo={useLogo}
                                setUseLogo={setUseLogo}
                                position={position}
                                setPosition={setPosition}
                                base_64={base_64}
                                send={send_for_calendar}
                                reGenerateImage={reGenerateImage}
                                generateImageBase64={generateImageBase64}
                                generate={generateImage}
                                not={not}
                                setNot={setNot}
                                description_image={description_image}
                                setDescriptionImage={setDescriptionImage}
                                styleImage={styleImage}
                                setStyleImage={setStyleImage}
                                shapeImage={shapeImage}
                                setShapeImage={setShapeImage}
                                setShowResizeModal={setShowResizeModal}
                                save={processSaveImage}
                                download={downloadImage}
                            />
                        </div>

                    </div>

                </div>

                <SaveImageModal onSave={add_to_folder} myfolders={myfolders == null ? [] : myfolders} image_name={image_name} setImageName={setImageName} folder={folder} setFolder={setFolder} setShowSavedModal={setShowSavedModal} open={show_save_modal} onClose={() => setShowSaveModal(false)} />

                <SavedModal onSend={() => send_for_calendar()} onClose={() => setShowSavedModal(false)} open={show_saved_modal} />

                <ResizeModal shapeImage={shapeImage} setShapeImage={setShapeImage} open={show_resize_modal} onClose={() => setShowResizeModal(false)} />

                <input id="actual" ref={ref} accept="image/*" onChange={onChangePicture} type="file" hidden={true} />
                <input id="actual" ref={ref1} accept="video/*" onChange={onChangePicture} type="file" hidden={true} />

                <wc-toast></wc-toast>

            </div>
    );
}

const mapStateToProps = state => {
    return {
        items: state._todoProduct
    }
}

export default connect(mapStateToProps, { SetId })(AICreate)